var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"right"},[_vm._v("Reach me at "),_c('a',{attrs:{"href":"mailto:mberkayersoy@gmail.com"}},[_vm._v("mberkayersoy@gmail.com")]),_vm._v(" or "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("through here")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }